import React from "react";
import { Provider as JotaiProvider } from "jotai";
import {
	ListaSolicitudesPendientesAprobacion,
	ModalAprobarSolicitudAusencia,
	ModalRechazarSolicitudAusencia,
	ModalAprobarMasivaSolicitudAusencia,
} from "./componentes";
import { VisorPdf } from "./VisorPdf";
import { ModalVerDocumentoAdjunto } from "./componentes/ModalVerDocumentoAdjunto";

const SolicitudesPendientesAprobarPage = () => {
	return (
		<JotaiProvider>
			<ListaSolicitudesPendientesAprobacion />
			<VisorPdf />
			<ModalAprobarSolicitudAusencia />
			<ModalAprobarMasivaSolicitudAusencia />
			<ModalRechazarSolicitudAusencia />
			<ModalVerDocumentoAdjunto />
		</JotaiProvider>
	);
};

export default SolicitudesPendientesAprobarPage;
